
import { useState, useEffect } from 'react';

export function useWordLinks(wordLinksCount: number) {
  // State for tracking which links should be highlighted
  const [highlightedLinks, setHighlightedLinks] = useState<boolean[]>([]);
  
  // State for showing/hiding the tooltip image
  const [showTooltipImage, setShowTooltipImage] = useState(false);
  
  // Track overall interaction state
  const [hasInteracted, setHasInteracted] = useState(false);
  
  // Track clicked links state
  const [clickedLinks, setClickedLinks] = useState<boolean[]>([]);
  
  // Initialize highlight states
  useEffect(() => {
    // Initialize with all false
    setHighlightedLinks(Array(wordLinksCount).fill(false));
    setClickedLinks(Array(wordLinksCount).fill(false));

    // Immediately start highlighting each link with 100ms delay between them
    if (wordLinksCount > 0) {
      for (let index = 0; index < wordLinksCount; index++) {
        const staggerDelay = setTimeout(() => {
          setHighlightedLinks(prev => {
            const updated = [...prev];
            updated[index] = true;
            return updated;
          });

          // Show tooltip immediately after the last link is highlighted
          if (index === wordLinksCount - 1) {
            setShowTooltipImage(true);
          }
        }, 100 * index); // 100ms delay between each link
      }
    }
  }, [wordLinksCount]);

  // Effect to hide tooltip only after interaction
  useEffect(() => {
    if (hasInteracted) {
      setShowTooltipImage(false);
    }
  }, [hasInteracted]);

  // Handle link clicks
  const handleLinkClick = (index: number) => {
    setClickedLinks(prev => {
      const updated = [...prev];
      updated[index] = true;
      return updated;
    });
    setHasInteracted(true); // Mark as interacted when a link is clicked
  };

  return {
    highlightedLinks,
    showTooltipImage,
    clickedLinks,
    hasInteracted,
    handleLinkClick
  };
}
